import { Box, FormControlLabel, Paper, RadioGroup, Typography } from '@material-ui/core';

import { FormQuestion, BarChartDataPoint, Visualization } from '@vyce/core/src/types';

import { FormResultResponses } from './FormResultResponses';
import { AppRoundedRadio } from '@vyce/core/src/components/inputs/AppRadio';

export const FormResultLinearScale = ({
  question,
  visualization,
  totalAnswers,
}: {
  question: FormQuestion;
  visualization: Visualization | undefined;
  totalAnswers: number;
}) => {
  const getOptionCount = (optionLabel: string): number => {
    if (visualization?.type !== 'bar_chart') return 0;
    const chartData = visualization.data as BarChartDataPoint[];
    const dataPoint = chartData?.find(point => point.label === optionLabel);
    return dataPoint?.count || 0;
  };

  const answerCount = (visualization?.data as BarChartDataPoint[])?.reduce(
    (acc, option) => acc + option.count,
    0
  );
  const noAnswersCount = totalAnswers - answerCount;

  const paperStyle = {
    padding: 24,
    width: '100%',
    height: '100%',
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };
  return (
    <Box width="100%">
      {visualization?.type === 'bar_chart' &&
        (visualization.data as BarChartDataPoint[])
          .filter(option => option.count > 0)
          .map((option, index) => (
            <Paper key={option.label} variant="outlined" style={{ ...paperStyle }}>
              <RadioGroup aria-label="single choice" value={option.value || null}>
                <Box m={1} display="flex" flexWrap="wrap" justifyContent="center">
                  {Array.from(
                    { length: question.answer.max ? +question.answer.max : 0 },
                    (_, i) => i + 1
                  ).map((index: number) => (
                    <Box
                      key={index}
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      position="relative"
                    >
                      <FormControlLabel
                        value={index}
                        control={
                          <AppRoundedRadio
                            checked={option.value === index}
                            style={{ marginLeft: 0 }}
                            color="primary"
                            name={index.toString()}
                          />
                        }
                        label={index}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column-reverse',
                          marginRight: 0,
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              </RadioGroup>

              <FormResultResponses count={getOptionCount(option.label)} names={[]} />
            </Paper>
          ))}
      <Paper variant="outlined" style={{ ...paperStyle }}>
        <Typography variant="body1" color="textSecondary">
          No answers
        </Typography>

        <FormResultResponses count={noAnswersCount} names={[]} />
      </Paper>
    </Box>
  );
};
